import { useListingData } from 'hooks';

const useQuery = () => {
    const { listingData } = useListingData();
    return [listingData.query, {}];
};

export default useQuery;
